import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IOccupationList {
  id: string;
  label: string;
  status: string;
}
export interface IAnnualIncomeList {
  id: string;
  value: string;
  label: string;
}
export interface IPEPList {
  id: string;
  label: string;
}
export interface INatureOfBusiness {
  id: string;
  label: string;
}
export interface IFARresponse {
  status: boolean | null;
  responseErrorDetail: string | null;
  totalPages: string | number;
  totalItems: string | number;
  logoutUser: boolean | null;
  data: {
    clientNum: string;
    clientType: string;
    surname: string;
    givname: string;
    salutation: string;
    fullName: string;
    nric: string;
    dob: string;
    gender: string;
    maritalStatus: string;
    nationality: string;
    race: string;
    homeNum: string;
    mobileNum: string;
    officeNum: string;
    faxNum: string | null;
    emailId: string;
    residential_Addr_1: string;
    residential_Addr_2: string;
    residential_Addr_3: string;
    residential_Addr_4: string;
    residential_Addr_5: string;
    residentialAddrCountry: string;
    residentialAddrPostalCode: string;
    agentTerminatedFlag: string;
    agentSourceOfBusiness: string;
  };
}

export interface SourceOfWealth {
  ET: boolean;
  Rental: boolean;
  Invest: boolean;
  Others: boolean;
}

export interface SourceOfFunds {
  ET2: boolean;
  SaleOfProperty: boolean;
  Savings: boolean;
  MaturityOfPolicy: boolean;
  Others2: boolean;
}

export interface IOccupation {
  selectedOccupation: { id: string; label: string; status: string };
  natureOfBusinessContent: string;
  natureOfBusiness: { label: string; id: string };
  employerName: string;
  annualIncome: IAnnualIncomeList;
  fcc: "YES" | "NO" | null;
  sourceOfWealth: SourceOfWealth;
  sourceOfFunds: SourceOfFunds;
  sourceOfWealthOthersContent: string;
  sourceOfFundsOthersContent: string;
  sourceOfWealthList: { id: string; text: string }[];
  sourceOfFundsList: { id: string; text: string }[];
}

export interface Tax {
  hasSingaporeTaxNumber: null | "N" | "Y";
  singaporeTaxNumber: string;
  reasonForNoTaxIdentificationNumber: string;
  otherTax: OtherTax[];
  reasonExplanation: string;
  crsOtherReason: string;
  crsReason: string;
}

export interface OtherTax {
  countryOfTaxResidence: string;
  hasOtherTaxNumber: null | "N" | "Y";
  taxIdentificationNumber: string;
  reasonForNoTaxIdentificationNumber: string;
  countryOfTax: string;
  reasonExplanation: string;
}
interface Declaration {
  occupationList: IOccupationList[];
  natureOfBusinessList: INatureOfBusiness[];
  annualIncomeList: IAnnualIncomeList[];
  declarationAcceptance: boolean;
  occupation: IOccupation;
  tax: Tax;
  PEPList: IPEPList[];
  declarationResponse: {
    updatedId: number | null;
    policyIllustration: string;
  };
  PEP: {
    isPEP: null | "YES" | "NO";
    PEPData?: {
      name?: string;
      relationship?: string;
      othersContent?: string;
    };
  };
  FARData: {
    isNeed?: string;
    name?: string;
    code?: string;
  };
  financialAdviserLink: boolean;
  arcCode: string,
  financialAdviser: {
    adviserData: IFARresponse | { data: null };
    autoAssignAgent: string;
  };
}
export enum FinancialAdviser {
  ARISTOTLE = "ARISTOTLE",
  USER_PREFERRED = "USER_PREFERRED",
  NO_AGENT = "NO_AGENT",
}

const initialState: Declaration = {
  occupationList: [],
  natureOfBusinessList: [],
  annualIncomeList: [],
  occupation: {
    annualIncome: { id: "", label: "", value: "" },
    employerName: "",
    natureOfBusinessContent: "",
    natureOfBusiness: { id: "", label: "" },
    selectedOccupation: { id: "", label: "", status: "" },
    fcc: null,
    sourceOfWealth: {
      ET: false,
      Rental: false,
      Invest: false,
      Others: false,
    },
    sourceOfWealthList: [
      { id: "ET", text: "Employment/Trade Income" },
      { id: "Rental", text: "Rental" },
      { id: "Invest", text: "Investment" },
      { id: "Others", text: "Others" },
    ],
    sourceOfWealthOthersContent: "",
    sourceOfFundsOthersContent: "",
    sourceOfFunds: {
      ET2: false,
      SaleOfProperty: false,
      Savings: false,
      MaturityOfPolicy: false,
      Others2: false,
    },
    sourceOfFundsList: [
      { id: "ET2", text: "Employment/Trade Income" },
      { id: "SaleOfProperty", text: "Sale of Property" },
      { id: "Savings", text: "Savings" },
      { id: "MaturityOfPolicy", text: "Maturity or Surrender of Policy" },
      { id: "Others2", text: "Others" },
    ],
  },
  tax: {
    hasSingaporeTaxNumber: null,
    singaporeTaxNumber: "",
    reasonForNoTaxIdentificationNumber: "",
    otherTax: [],
    reasonExplanation: "",
    crsOtherReason: "",
    crsReason: "",
  },
  PEPList: [],
  PEP: {
    isPEP: null,
    PEPData: undefined,
  },
  declarationResponse: {
    updatedId: null,
    policyIllustration: "",
  },
  declarationAcceptance: false,
  FARData: {
    isNeed: "",
    name: "",
    code: "",
  },
  financialAdviserLink: false,
  arcCode:"",
  financialAdviser: {
    adviserData: {
      logoutUser: null,
      responseErrorDetail: "",
      status: null,
      totalItems: "",
      totalPages: "",
      data: {
        clientNum: "",
        clientType: "",
        surname: "",
        givname: "",
        salutation: "",
        fullName: "",
        nric: "",
        dob: "",
        gender: "",
        maritalStatus: "",
        nationality: "",
        race: "",
        homeNum: "",
        mobileNum: "",
        officeNum: "",
        faxNum: null,
        emailId: "",
        residential_Addr_1: "",
        residential_Addr_2: "",
        residential_Addr_3: "",
        residential_Addr_4: "",
        residential_Addr_5: "",
        residentialAddrCountry: "",
        residentialAddrPostalCode: "",
        agentTerminatedFlag: "",
        agentSourceOfBusiness: "",
      },
    },
    autoAssignAgent: "",
  },
};

const step3Slice = createSlice({
  name: "Ever_Green_Step_3",
  initialState,
  reducers: {
    updateOccupationList: (state, action: PayloadAction<IOccupationList[]>) => {
      state.occupationList = action.payload;
    },
    updateSelectedOccupation: (
      state,
      action: PayloadAction<{ id: string; label: string; status: string }>
    ) => {
      state.occupation.selectedOccupation = action.payload;
    },
    updateEmpName: (state, action: PayloadAction<string>) => {
      state.occupation.employerName = action.payload;
    },
    updateNameOfBusinessContent: (state, action: PayloadAction<string>) => {
      state.occupation.natureOfBusinessContent = action.payload;
    },
    updateNameOfBusiness: (
      state,
      action: PayloadAction<{ label: string; id: string }>
    ) => {
      state.occupation.natureOfBusiness = action.payload;
    },
    updateAnnualIncome: (state, action: PayloadAction<IAnnualIncomeList>) => {
      state.occupation.annualIncome = action.payload;
    },
    updateAnnualIncomeList: (
      state,
      action: PayloadAction<IAnnualIncomeList[]>
    ) => {
      state.annualIncomeList = action.payload;
    },
    updateSourceOfwealth: (state, action: PayloadAction<any>) => {
      state.occupation.sourceOfWealth = action.payload;
    },
    updateSourceOfFunds: (state, action: PayloadAction<any>) => {
      state.occupation.sourceOfFunds = action.payload;
    },
    updateSourceOfWealthContent: (state, action: PayloadAction<string>) => {
      state.occupation.sourceOfWealthOthersContent = action.payload;
    },
    updateSourceOfFundsContent: (state, action: PayloadAction<string>) => {
      state.occupation.sourceOfFundsOthersContent = action.payload;
    },
    updateFARData: (
      state,
      action: PayloadAction<
        Partial<{
          isNeed: string;
          name: string;
          code: string;
        }>
      >
    ) => {
      state.FARData = {
        ...state.FARData,
        ...action.payload,
      };
    },
    updateFinancialAdviser: (
      state,
      action: PayloadAction<IFARresponse | { data: null }>
    ) => {
      state.financialAdviser.adviserData = action.payload;
    },
    updateArcCode:(state, action: PayloadAction<string>)=>{
      state.arcCode = action.payload
    },
    updateFinancialAdviserLink: (state, action: PayloadAction<boolean>) => {
      state.financialAdviserLink = action.payload;
    },
    updateAssignedAgentOption: (state, action: PayloadAction<string>) => {
      state.financialAdviser.autoAssignAgent = action.payload;
    },
    updateDeclarationResponse: (
      state,
      action: PayloadAction<{
        updatedId: number | null;
        policyIllustration: string;
      }>
    ) => {
      state.declarationResponse = action.payload;
    },
    updateDeclarationAcceptance: (state, action: PayloadAction<boolean>) => {
      state.declarationAcceptance = action.payload;
    },
    updateNatureOfBusinessList: (
      state,
      action: PayloadAction<INatureOfBusiness[]>
    ) => {
      state.natureOfBusinessList = action.payload;
    },
    updateTaxData: (state, action: PayloadAction<any>) => {
      state.tax = {
        ...state.tax,
        ...action.payload,
      };
    },
    updatePEPstatus: (state, action: PayloadAction<"YES" | "NO">) => {
      state.PEP.isPEP = action.payload;
    },
    updatePEPdata: (
      state,
      action: PayloadAction<{
        name?: string;
        relationship?: string | undefined;
        othersContent?: string;
      }>
    ) => {
      state.PEP.PEPData = action.payload;
    },
    updatePEPList: (state, action: PayloadAction<IPEPList[]>) => {
      state.PEPList = action.payload;
    },
    updateFcc: (state, action: PayloadAction<"YES" | "NO">) => {
      state.occupation.fcc = action.payload;
    },
    updateStep3ToDefault: (state, action) => ({
      ...initialState,
    }),
  },
});

export const {
  updateDeclarationResponse,
  updateOccupationList,
  updateSelectedOccupation,
  updateEmpName,
  updateNameOfBusiness,
  updateNameOfBusinessContent,
  updateAnnualIncome,
  updateAnnualIncomeList,
  updateSourceOfFunds,
  updateSourceOfwealth,
  updateSourceOfWealthContent,
  updateSourceOfFundsContent,
  updateFinancialAdviser,
  updateAssignedAgentOption,
  updateNatureOfBusinessList,
  updatePEPstatus,
  updatePEPdata,
  updateTaxData,
  updatePEPList,
  updateFcc,
  updateFARData,
  updateDeclarationAcceptance,
  updateStep3ToDefault,
  updateFinancialAdviserLink,
  updateArcCode
} = step3Slice.actions;

export default step3Slice.reducer;
